import React, { useEffect } from "react";
import { StartActivity, sleep } from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";
import {MAN_PL_CONST} from "../../../../../constants/ActionEnums/ManActionEnums";
import {GetSelected} from "../../../../common/tableHandler/manipulateTable";
import {InitiateProcessAction} from "../../../../../api/omnimap/omnimapActions";

const PlaatsInUitvoering = () => {
  useEffect(async () => {
    $("#plaats_in_uitvoering").on("show.bs.modal", async function (event) {
      var selectedIds = [];
    });
  });

  const handleSubmit = () => {
    $("#cover-spin").show(0);
    // var model = { status: 'test' };
    /*var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    StartActivity(
      model,
      selectedIds,
      "56785c54-8059-46ae-8b7f-250ce971a539",
      UitvoeringVerplaatst,
      window.$mm_management_units_token
    ); */

    // const model = {
    //   "action": MAN_PL_CONST.PLACE_IN_WORK_PLAN,
    //   "werkplan_identification": workPlanId,
    //   "identifications": GetSelected()
    // }

    const model = {
      "action": MAN_PL_CONST.PLACE_IN_EXECUTION,
      "identifications": GetSelected()
    }

    InitiateProcessAction(model, MAN_PL_CONST.END_POINT).then(()=>{
      UitvoeringVerplaatst()
    }).catch(()=>{
      alert('Something went wrong!')
      $("#cover-spin").hide(0);
    })


  };
  const UitvoeringVerplaatst = () => {
    sleep(900).then(() => {
      $("#plaats_in_uitvoering").modal("hide");
      window.$mm_schedule_tableReload();
      /*omnimap
        .FillTableAction(
          window.$mm_schedule_lastUsedTableFilter,
          1,
          window.$mm_management_units_token
        )
        .then((result) => {
          CallBackFunctions.FillTableCallBack(result, 1);
        });*/
    });
  };
  return (
    <div
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      id="plaats_in_uitvoering"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Plaats in uitvoering</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <h1>Toelichting</h1>
            <p>
              Door op 'Verwerken' te klikken zal de werkregel naar de Gisratio
              app verstuurd worden.
            </p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              id="save_plaats_in_uitvoering"
              className="btn-modal"
              onClick={handleSubmit.bind(this)}
            >
              Verwerken
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaatsInUitvoering;
